export function readValue<T = string>({
	key,
	defaultValue,
	storage = globalThis.sessionStorage,
}: {
	key: string;
	defaultValue?: T;
	storage?: Storage;
}): T | undefined {
	if (!storage) {
		console.warn(`Storage is not available. Skipping read for key: ${key}`);
		return;
	}

	try {
		const item = storage.getItem(key);

		if (item) {
			return JSON.parse(item) as T;
		} else if (defaultValue) {
			storage.setItem(key, JSON.stringify(defaultValue));
			return defaultValue;
		}
	} catch (err) {
		console.warn('Failed to read local storage value. Falling back to non-JSON parsing or default value', err);
		return ((storage.getItem(key) as string) || defaultValue) as T;
	}
}

export function writeValue<T = string>({
	key,
	value,
	storage = globalThis.sessionStorage,
}: {
	key: string;
	value: T;
	storage?: Storage;
}) {
	if (!storage) {
		console.warn(`Storage is not available. Skipping write for key: ${key}`);
		return;
	}

	try {
		const stringifyVal = JSON.stringify(value);
		storage.setItem(key, stringifyVal);
	} catch {
		if (typeof value === 'string') {
			storage.setItem(key, value);
		} else {
			throw new Error(
				`Failed to write ${key} to storage. Provided value is not a string and is not serializable.`
			);
		}
	}
}
